import { SIDEBAR_WIDTH } from '../constants';

export const COURSE_CARD_HEIGHT = 89;
export const POPUP_LEFT_OFFSET = 8;
export const POPUP_MASK_WIDTH = 16;
export const HOVER_CARD_HEIGHT = 250;
export const SUBNAVBAR_HEIGHT = 68;

export const getPopupPosition = (positionData: DOMRect): { top: number; left: number } => {
  const height = positionData.height > COURSE_CARD_HEIGHT ? COURSE_CARD_HEIGHT : positionData.height;

  const subnavbarPosition = document.getElementById('subnavbar')?.getBoundingClientRect();

  const offset =
    subnavbarPosition && subnavbarPosition.y < SUBNAVBAR_HEIGHT ? SUBNAVBAR_HEIGHT - subnavbarPosition.y : 0;

  return {
    top: positionData.top - (HOVER_CARD_HEIGHT / 2 - height / 2) + offset - POPUP_MASK_WIDTH,
    left: SIDEBAR_WIDTH - POPUP_MASK_WIDTH,
  };
};
